import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left Panel */}
      <div className="relative w-full lg:w-1/2 min-h-[400px] md:min-h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20cream%20trench%20coat%20carrying%20shopping%20bags%20walking%20through%20sunlit%20urban%20street%20with%20modern%20architecture%2C%20candid%20street%20style%20photography%2C%20warm%20golden%20hour%20light%20streaming%20between%20buildings%2C%20blurred%20background%20with%20boutique%20storefronts%2C%20fashionable%20aspirational%20lifestyle%20scene&width=900&height=700&seq=cta-left-v2-f3k7&orientation=landscape"
          alt="Official Hipobuy Spreadsheet Store - Curated Product Selection"
          title="Hipobuy Spreadsheet Official Store"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 p-8 md:p-12">
          <span className="text-xs md:text-sm font-semibold text-background-50/80 uppercase tracking-wider">Official Store</span>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mt-2">
            hipobuy<br />sheet<br />buy it now
          </h2>
        </div>
      </div>

      {/* Right Panel */}
      <div className="flex flex-col items-center justify-center w-full lg:w-1/2 bg-background-50 py-16 md:py-20 px-6 md:px-12">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 text-center leading-tight">
          Ready To<br />Shop?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-md mt-6 leading-relaxed">
          Explore thousands of curated products across all categories on our main platform. 
          From fashion essentials to accessories, our <strong>Hipobuy Spreadsheet</strong> resources help you find exactly what you need.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 mt-8 px-10 py-4 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Start Shopping Now
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
        <Link
          to="/hipobuy-spreadsheet-guide"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-4 transition-colors cursor-pointer"
        >
          or read our complete guide first →
        </Link>
      </div>
    </section>
  );
}